module.exports = __webpack_public_path__ + "img/cuve-cubique.a02f98f2.png";